import { IsNotEmpty, IsOptional, IsInt, IsObject, IsArray, ValidateNested, IsString, MaxLength } from 'class-validator';

import { TaxonomyValues } from '../../taxonomy';
import { NomenclatureUnitCompositionRequest } from '../../nomenclature/nomenclature-unit-composition.request';

export class OrderPositionUpdateRequest {
    @IsOptional()
    @IsInt()
    public id?: number;

    @IsInt()
    public orderId: number;

    @IsString()
    @IsNotEmpty()
    public nomPositionUuid: string;

    @IsInt()
    public qty: number;

    @IsOptional()
    @IsObject()
    public values?: TaxonomyValues;

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    public composition?: NomenclatureUnitCompositionRequest[];

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public comment?: string;

    constructor(data?: Partial<OrderPositionUpdateRequest>) {
        this.id = data?.id;
        this.orderId = data?.orderId;
        this.nomPositionUuid = data?.nomPositionUuid;
        this.qty = data?.qty;
        this.values = data?.values;
        this.composition = Array.isArray(data?.composition)
            ? data.composition.map(item => new NomenclatureUnitCompositionRequest(item))
            : data?.composition;
        this.comment = data?.comment;
    }
}
